var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { ConfigurePermissionComponent } from '../../../settings/configure-permission/configure-permission.component';
var ControlPermissionSettingComponent = /** @class */ (function (_super) {
    __extends(ControlPermissionSettingComponent, _super);
    function ControlPermissionSettingComponent(injector, modalService, configPermissionServiceProxy) {
        var _this = _super.call(this, injector) || this;
        _this.modalService = modalService;
        _this.configPermissionServiceProxy = configPermissionServiceProxy;
        _this.permissionChange = new EventEmitter();
        _this.canInitDropDown = false;
        _this.refreshWhenPermissionModalClose = function (newAllPermissions) {
            _this.allPermissions = newAllPermissions || [];
            _this.filterPermission();
            abp.ui.setBusy(_this.dropdownContainer.nativeElement);
            _this.canInitDropDown = false;
            setTimeout(function () {
                abp.ui.clearBusy(_this.dropdownContainer.nativeElement);
                _this.canInitDropDown = true;
            }, 500);
        };
        return _this;
    }
    ControlPermissionSettingComponent.prototype.ngOnInit = function () {
        var self = this;
        if (self.permissionSettingResult === undefined) {
            self.permissionSettingResult = { PermissionList: [], PermissionEnabled: false };
        }
        self.permissionsSelected = self.permissionSettingResult.PermissionList || [];
        self.permissionEnabled = self.permissionSettingResult.PermissionEnabled;
        self.loadConfigurePermissions().then(function () {
            self.filterPermission();
            self.canInitDropDown = true;
            self.initDropDown();
        });
        abp.event.on('control.permission.manangeListModalClose', this.refreshWhenPermissionModalClose);
    };
    ControlPermissionSettingComponent.prototype.ngOnDestroy = function () {
        abp.event.off('control.permission.manangeListModalClose', this.refreshWhenPermissionModalClose);
    };
    ControlPermissionSettingComponent.prototype.loadConfigurePermissions = function () {
        var self = this;
        return this.configPermissionServiceProxy.getConfigurePermissions(this.configureId).toPromise().then(function (result) {
            self.allPermissions = result.items || [];
        });
    };
    ControlPermissionSettingComponent.prototype.filterPermission = function () {
        var self = this;
        self.dropdownOptions = self.allPermissions.map(function (item) {
            return { id: item.tag, name: item.name };
        });
        self.permissionsSelected = _.filter(self.permissionsSelected, function (r) { return self.allPermissions.findIndex(function (s) { return s.tag === r; }) !== -1; });
        this.permissionChange.emit({
            PermissionEnabled: this.permissionEnabled, PermissionList: this.permissionsSelected
        });
    };
    ControlPermissionSettingComponent.prototype.onPermissionChooseChange = function () {
        this.permissionChange.emit({
            PermissionEnabled: this.permissionEnabled, PermissionList: this.permissionsSelected
        });
    };
    ControlPermissionSettingComponent.prototype.initDropDown = function () {
        this.dropdownSettings = {
            containerClasses: 'dropdown-multi',
            buttonClasses: 'angular-dropdown-multiselect-chop-text-button btn btn-default btn-block',
            enableSearch: false,
            checkedStyle: 'fontawesome',
            dynamicTitleMaxItems: 3,
            displayAllSelectedText: false
        };
        this.dropdownTexts = {
            checkAll: this.l('AngularDropdownMultiSelect_CheckAll'),
            uncheckAll: this.l('AngularDropdownMultiSelect_UncheckAll'),
            checked: this.l('AngularDropdownMultiSelect_Checked'),
            checkedPlural: this.l('AngularDropdownMultiSelect_CheckedPlural'),
            searchPlaceholder: this.l('AngularDropdownMultiSelect_SearchPlaceholder'),
            defaultTitle: this.l('AngularDropdownMultiSelect_DefaultTitle'),
            allSelected: this.l('AngularDropdownMultiSelect_AllSelected'),
            searchEmptyResult: this.l('AngularDropdownMultiSelect_NoItems')
        };
    };
    ControlPermissionSettingComponent.prototype.showPermissionList = function () {
        var _this = this;
        var modalRef = this.modalService.show(ConfigurePermissionComponent, {
            initialState: {
                configureId: this.configureId,
                active: true
            },
            backdrop: 'static'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            _this.refreshWhenPermissionModalClose(result);
            onClosedSub.unsubscribe();
        });
    };
    ControlPermissionSettingComponent.prototype.changepermissionCheck = function () {
        if (this.permissionEnabled === false) {
            this.permissionsSelected = [];
        }
        this.permissionChange.emit({
            PermissionEnabled: this.permissionEnabled, PermissionList: this.permissionsSelected
        });
    };
    __decorate([
        Input()
    ], ControlPermissionSettingComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], ControlPermissionSettingComponent.prototype, "permissionSettingResult", void 0);
    __decorate([
        Output()
    ], ControlPermissionSettingComponent.prototype, "permissionChange", void 0);
    __decorate([
        ViewChild('dropdownContainer', { static: false })
    ], ControlPermissionSettingComponent.prototype, "dropdownContainer", void 0);
    ControlPermissionSettingComponent = __decorate([
        Component({
            selector: 'control-permission-setting',
            template: "<div class=\"fe-form-group clearfix\"> <div class=\"fe-option-head-transverse\"> <label> <input type=\"checkBox\" [(ngModel)]=\"permissionEnabled\" (change)=\"changepermissionCheck()\"/> <span>{{lc(\"PermissionSetting\")}}</span> </label> </div> <div class=\"fe-option-body-transverse float-left flex clearfix\" *ngIf=\"permissionEnabled==true\" #dropdownContainer> <label class=\"float-left\">{{lc(\"ChoosePermission\")}}:</label> <ss-multiselect-dropdown class=\"choose-authority float-left\" name=\"permissions\" [options]=\"dropdownOptions\" *ngIf=\"canInitDropDown\" (ngModelChange)=\"onPermissionChooseChange()\" [settings]=\"dropdownSettings\" [texts]=\"dropdownTexts\" [(ngModel)]=\"permissionsSelected\"></ss-multiselect-dropdown> <button type=\"button\" class=\"fe-btn fe-btn-small fe-btn-operate fe-btn-manage float-left left-margin\" (click)=\"showPermissionList()\"> {{lc(\"PermissionManangementShort\")}} </button> </div> </div> ",
            styles: [" .checkadjust { white-space: nowrap; margin-top: 1rem; margin-left: 0.5rem; } .addtopSpace { margin-top: 5px; } .btnr { color: #333; background-color: #f4f4f4; border: 1px solid #ddd; &:hover { color: #333; } &:link { color: #333; } } .choose-label{ top: 9px; white-space: nowrap; padding-left: 10px; } .choose-authority{ width: calc(100% - 152px); }"]
        })
    ], ControlPermissionSettingComponent);
    return ControlPermissionSettingComponent;
}(ConfigureComponentBase));
export { ControlPermissionSettingComponent };
